<template>
<!-- 生产单列表 -->
  <div>
      <el-button type="primary" @click="productOrderAdd()" style="" size="mini">新建生产单</el-button>
      <el-table :data="responseData" :header-cell-style="{'text-align':'center'}"
        :cell-style="{'padding':'0px'}" border stripe>
        <!--生产单号-->
        <el-table-column fixed="left" prop="number" label="生产单号" width="80" align="center">
          <template slot-scope="data">
            <el-link type="primary" @click="goToProductOrderDetails(data.row.id)">
              {{ data.row.number }}
            </el-link>
          </template>
        </el-table-column>
        <!--进度-->
        <el-table-column label="生产单进度" fixed="left" prop="productPrecent" width="90" align="right"/>
        <!--可拖动生产单数据-->
        <el-table-column  v-for="(obj,name,index) in productParams" :key="name+index" :label="obj.value" width="100" :align="obj.align">
         <template slot-scope="data">
             {{ data.row[name] }}
           </template>
        </el-table-column>
        <!--工单号-->
        <el-table-column label="工单编号" width="100" align="center">
           <template slot-scope="data">
             <p v-for="(item, index) in data.row.workOrders" :key="index">
                <el-link type="primary" @click="$refs.workOrderDetails.show(item.id)">
                    {{ item.number }}
                </el-link>
             </p>
           </template>
        </el-table-column>
        <!--工单数据-->
        <el-table-column v-for="(obj,name,index) in workOrderParams" :key="index"
           :label="obj.value" :width="obj.width" :align="obj.align">
           <template slot-scope="data">
             <p v-for="(item, index) in data.row.workOrders" :key="index">
                {{ item[name] }}
             </p>
           </template>
        </el-table-column>
        <!--进度-->
        <el-table-column label="工单进度" fixed="right" width="100" align="right">
           <template slot-scope="data">
             <p v-for="(item, index) in data.row.workOrders" :key="index">
                {{ item.precent }}
             </p>
           </template>
        </el-table-column>
        <!--操作-->
        <el-table-column fixed="right" label="操作" width="250" align="center">
            <template slot-scope="data">
              <el-button type="text" size="mini" @click="show(data.row.id)">打印</el-button>
              <el-button type="text" size="mini" @click="open(data)">订单说明</el-button>
              <el-button type="text" size="mini" @click="changeState(data.row)" v-if="data.row.stateIndex === 0">
                切至待产
              </el-button>
              <el-button type="text" size="mini" @click="changeState(data.row)" v-if="data.row.stateIndex === 2">
                结束生产
              </el-button>
            </template>
        </el-table-column>
      </el-table>
      <el-pagination
       style="text-align: center"
       background
       layout="prev, pager, next"
       @current-change="handleCurrentChange"
       :page-size="pageInfo.size"
       :current-page="pageInfo.page"
       :page-count="totalPages">
      </el-pagination>
    <work-order-details ref="workOrderDetails"/>
  </div>
</template>

<script>
import { workOrderDetails } from '@/components/projectComponents'
export default {
  components: { workOrderDetails },
  name: 'productOrderList',
  data () {
    return {
      responseData: [],
      remarksButton: [],
      pageInfo: {
        page: 1,
        size: 15
      },
      totalPages: 0,
      productParams: {
          fabricName: { value: '胚布', align: 'center' },
          customer: { value: '客户', align: 'center' },
          createTime: { value: '创建日期', align: 'center' },
          consignTime: { value: '交付日期', align: 'center' },
          amount: { value: '订单数量(米)', align: 'right' },
          status: { value: '生产单状态', align: 'center' }
      },
      workOrderParams: {
          nowProducedLength: { value: '已生产数量(米)', align: 'right', width: '100' },
          predictProducedLength: { value: '预生产数量(米)', align: 'right', width: '100' },
          productInProgress: { value: '工单状态', align: 'center', width: '70' },
          productStartTime: { value: '首次上机时间', align: 'center', width: '150' },
          productFinishTime: { value: '最后下机时间', align: 'center', width: '150' }
      }
    }
  },
  methods: {
    // 跳转至工单打印界面
    show(id) {
      const routeData = this.$router.resolve({ path: `/product/productOrderPrint/${id}` })
      window.open(routeData.href, '_blank')
    },
    // 跳转至新建生产单列表
    productOrderAdd () {
      this.$router.push('productOrderList/productOrderAdd')
    },
    // 显示工单补充说明，以message的形式，因为可以有100字，不便放于列表中
    open(data) {
      this.$msgbox({
          title: '订单补充说明',
          message: ('span', null, data.row.remarks)
      })
    },
    // 分页切换
    handleCurrentChange (newNum) {
      this.getProductOrederList(newNum)
    },
    // 改变工单的状态
    changeState(data) {
      // '此操作将把工单的状态从[准备中]变为[待生产]'
      // TODO 枚举需要抽成公用的文件
      const stateIndex = data.stateIndex
      if (stateIndex === 0 || stateIndex === 2) {
        const tipContent = stateIndex === 0 ? '工单状态将从[准备中]变为[待生产]。'
          : '工单状态将从[暂停中]变为[已完成]。'
        this.$confirm(tipContent, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$requestBase({
            url: 'v1/factory/product-order/change/state',
            method: 'get',
            params: {
              productOrderId: data.id,
              type: stateIndex === 0 ? 0 : 1
            }
          }).then(res => {
            this.getProductOrederList(this.pageInfo.page)
          })
        })
      }
    },
    // 获取生产单分页列表
    getProductOrederList (val) {
      this.pageInfo.page = val
      this.$requestBase({
        url: 'v1/factory/product-order/list',
        method: 'get',
        params: this.pageInfo
      }).then(res => {
        this.responseData = this.formatResponse(res.data.list)
        this.totalPages = res.data.pages
      })
    },
    // 格式化生产单列表
    formatResponse(response) {
      response.forEach((item, index) => {
        item.createTime = this.utils.timestampToTime(item.createTime, 2)
        item.consignTime = this.utils.timestampToTime(item.consignTime, 2)
        item.stateIndex = this.utils.formatEnum(item.status)[0]
        item.status = this.$enum.orderStatus[this.utils.formatEnum(item.status)[0]]
        item.productPrecent = item.amount / 100
        item.amount = item.amount / 100
        item.countProducedLength = 0
        const workOrders = item.workOrders
        if (workOrders.length > 0) {
          workOrders.forEach((workOrder, i) => {
            workOrder.countProducedLength += workOrder.nowProducedLength
            workOrder.precent = workOrder.predictProducedLength <= 0 ? 0 : ((workOrder.nowProducedLength / workOrder.predictProducedLength) * 100).toFixed(2) + '%'
            workOrder.productInProgress = workOrder.productInProgress ? '生产中' : '未生产'
            workOrder.nowProducedLength = workOrder.nowProducedLength / 100
            workOrder.predictProducedLength = workOrder.predictProducedLength / 100
            workOrder.productFinishTime = this.utils.timestampToTime(workOrder.productFinishTime)
            workOrder.productStartTime = this.utils.timestampToTime(workOrder.productStartTime)
         })
        }
        item.productPrecent = item.productPrecent <= 0 ? '0.00%' : ((item.countProducedLength / item.productPrecent)).toFixed(2) + '%'
      })
      return response
    },
    // 路由至生产单详情
    goToProductOrderDetails(productOrderId) {
      this.$router.push(`productOrderList/productOrderDetalis/${productOrderId}`)
    }
  },
  mounted () {
    this.getProductOrederList(1)
  },
  activated () {
    this.getProductOrederList(1)
  }
}
</script>

<style lang="scss" scoped>
.define-table-container {
  margin-left: -10px !important;
}
// #bianji {
//   cursor: pointer;
//   alt: '编辑';
// }
p{
  // border: 1px solid #EBEEF5;
  // line-height: 0;
  padding: 0;
  margin: 0
}
</style>
